<template>
  <div>
    <div id="JobCardUtilies" class="d-flex">
      <div
        class=" d-flex flex-column justify-content-center  align-items-start bd-highlight mb-3 border-bottom border-light"
        style="width:65%"
      >
        <h1 style="font-weight: bold; font-size:36px;">
          {{ job.name }}
        </h1>
        <h3 style=" padding-top:30px; font-size: 24px; font-weight: bold; ">
          Job Description
        </h3>
        <p
          v-html="job.description"
          style="color:#949494; font-size: 16px; padding:10px 0px;"
        ></p>
        <h3 style=" padding-top:30px; font-size: 24px; font-weight: bold;">
          Qualifications
        </h3>
        <p
          style="color:#949494; font-size: 16px; padding:10px 0px;"
          v-html="job.qualifications"
        ></p>
        <h3 style=" padding-top:30px; font-size: 24px; font-weight: bold;">
          Responsibilities
        </h3>
        <p
          style="color:#949494; font-size: 16px; padding:10px 0px;"
          v-html="job.responsibilities"
        ></p>
      </div>
      <div style="width:auto; margin-left:10px">
        <div
          class="position-fixed p-3 d-flex flex-column"
          style="background: #F9F9F9; border-radius: 15px; width:20%"
        >
          <div class="p-2 bd-highlight d-flex align-items-center">
            <img
              src="@/assets/svg/Location.svg"
              style="margin-right:5px"
              alt=""
            />
            {{ job.location }}
          </div>
          <div class="p-2 bd-highlight">
            <img src="@/assets/svg/Work.svg" style="margin-right:5px" alt="" />
            {{ job.workType }}
          </div>
          <div class="p-2 d-flex justify-content-center" style="width:100%">
            <a
              class=""
              :href="job.externalLinks"
              target="_blank"
              style="
                     width:100%; 
                     background: linear-gradient(90deg, #87E7FD 0%, #545CCF 100%);
                     border-radius: 18px; 
                     color:#FFFFFF; 
                     font-style: normal;
                     font-weight: bold;
                     font-size: 14px;
                     text-align: center;
                     padding:5px 10px;
                    "
            >
              Apply Now
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "JobCardUtilies",
  props: {
    job: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style></style>
